import type { NumberFormatterOptions } from "../../../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import NumberFormatRadioGroup from "./NumberFormatRadioGroup.tsx";

enum AbbreviationType {
  None = "",
  Thousand = "K",
  Million = "M",
}

interface Props {
  formatOptions: NumberFormatterOptions | undefined;
  applyFormat: (formatOptions: NumberFormatterOptions) => void;
}

const abbreviationOptions = [
  { label: "None", value: AbbreviationType.None },
  { label: "Thousand", value: AbbreviationType.Thousand },
  { label: "Million", value: AbbreviationType.Million },
];

export const Abbreviation = ({ formatOptions, applyFormat }: Props) => {
  const changeAbbreviation = (abb: AbbreviationType) => {
    const copiedObject = {
      ...formatOptions,
      percentage: false,
      convertToPercentage: false,
      abbreviation: abb,
    } as NumberFormatterOptions;

    if (abb === AbbreviationType.None) {
      copiedObject.abbreviation = undefined;
    }
    applyFormat(copiedObject);
  };

  return (
    <NumberFormatRadioGroup
      value={formatOptions?.abbreviation as AbbreviationType | undefined}
      label="Abbreviation"
      options={abbreviationOptions}
      onValueChanged={changeAbbreviation}
    />
  );
};

export default Abbreviation;
